import { render, staticRenderFns } from "./HomeCooperate.vue?vue&type=template&id=ed4f88ba&scoped=true&"
import script from "./HomeCooperate.vue?vue&type=script&lang=js&"
export * from "./HomeCooperate.vue?vue&type=script&lang=js&"
import style0 from "./HomeCooperate.vue?vue&type=style&index=0&id=ed4f88ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4f88ba",
  null
  
)

component.options.__file = "HomeCooperate.vue"
export default component.exports